/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Volo_Abp_Account_Web_Areas_Account_Controllers_Models_LoginResultType {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
}
